import { FC, useState } from 'react';
import { observer } from 'mobx-react';
import { BodyText, Headline, Icon, Stack, Link, Button, Card } from '@servicetitan/design-system';
import { Preferences } from '../../components/preferences/preferences';
import { PageWrapper } from '../../components/page-wrapper/page-wrapper';
import { SubscriptionStore } from '../../stores/subscription.store';
import { useDependencies } from '@servicetitan/react-ioc';
import classnames from 'classnames';
import * as Styles from '../../components/page-wrapper/page-wrapper.module.less';

export const OptInPage: FC = observer(() => {
    const [showPreferences, setShowPreferences] = useState(false);
    const [marketingStore] = useDependencies(SubscriptionStore);

    const handleOptInRequest = () => {
        marketingStore.sendDoubleOptIn();
    };

    return (
        <PageWrapper>
            <Card raised className={classnames(Styles.optInPage, 'qa-page-main-card')}>
                {!showPreferences ? (
                    !marketingStore.submitted ? (
                        <Stack
                            direction="column"
                            alignItems="center"
                            className={classnames(Styles.container, 'opt-in-prompt')}
                        >
                            <Icon name="add_alert" size="48px" />
                            <Headline size="large" className="m-y-2">
                                Confirm Your Subscription!
                            </Headline>
                            <BodyText className="m-y-2">
                                You're almost there! Please confirm that you'd like to opt in to
                                receive updates from us.
                            </BodyText>
                            <Button
                                className="qa-unsubscribe-button m-t-3"
                                onClick={handleOptInRequest}
                                disabled={false}
                                primary
                            >
                                Yes, Opt Me In
                            </Button>
                        </Stack>
                    ) : (
                        <Stack direction="column" alignItems="center">
                            <Icon name="notifications" size="48px" />
                            <Headline size="large" className="m-y-2">
                                Opted In
                            </Headline>
                            <BodyText>
                                You have <b>opted in</b> to receiving messages from us.
                            </BodyText>
                            <BodyText>
                                <Link
                                    onClick={() => setShowPreferences(true)}
                                    color="primary"
                                    className="qa-update-preferences-link"
                                >
                                    Click here
                                </Link>{' '}
                                to update your email subscriptions.
                            </BodyText>
                        </Stack>
                    )
                ) : (
                    <Preferences />
                )}
            </Card>
        </PageWrapper>
    );
});
